module.exports = __webpack_public_path__ + "resources/img/img_security_TLS_SSL_certificate1.865233f18e42e860e772f3aa1485aadb.png";